module.exports = __webpack_public_path__ + "assets/img/03cbe0571e872207d65985aac203cc98.png";